import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
  standalone: false
})
export class TruncatePipe implements PipeTransform {

  /**
   * Truncates a string to a specified number of characters, appending '...' if truncated.
   *
   * @param value The input string to truncate.
   * @param limit The maximum number of characters to display before truncating.
   * @returns The truncated string.
   */
  transform(value: string | null | undefined, limit: number): string {
    // Handle cases where the input value might be null or undefined
    if (value === null || value === undefined) {
      return ''; // Or you could return value directly, depending on desired behavior
    }

    // Convert value to string in case it's a number or other non-string type
    const strValue = String(value);

    // If the string is already shorter than or equal to the limit, return it as is
    if (strValue.length <= limit) {
      return strValue;
    }

    // Truncate the string and append '...'
    return strValue.substring(0, limit) + '...';
  }
}